export const MAX_CHARS_REGISTER_BUTTON = 40;
